(() => {
  'use strict';
  const initialized = new WeakSet();
  function initProduct(root) {
    const section = root.matches?.('[data-product-section]') ? root : root.querySelector?.('[data-product-section]');
    if (!section || initialized.has(section)) return;
    initialized.add(section);
    const variant = section.querySelector('[data-variant-select]');
    const variantInput = section.querySelector('input[name="id"]');
    const plan = section.querySelector('[data-tj-selling-plan]');
    const quantity = section.querySelector('[data-tj-quantity]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare-price]');
    const originalPrice = price?.textContent || '';
    const originalCompare = compare?.textContent || '';
    const planDataNode = section.parentElement?.querySelector('[data-tj-selling-plan-data]') || section.querySelector('[data-tj-selling-plan-data]');
    let planData = {};
    try { planData = planDataNode ? JSON.parse(planDataNode.textContent) : {}; } catch (_) { planData = {}; }
    const currentVariantId = () => variant?.value || variantInput?.value || '';
    const update = () => {
      const option = variant?.options[variant.selectedIndex];
      if (quantity && option) {
        const minimum = Number(option.dataset.quantityMin || 1);
        const increment = Number(option.dataset.quantityStep || 1);
        const maximum = option.dataset.quantityMax ? Number(option.dataset.quantityMax) : Infinity;
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (Number.isFinite(maximum)) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        let requested = Number(quantity.value);
        if (!Number.isFinite(requested)) requested = minimum;
        requested = minimum + Math.round((requested - minimum) / increment) * increment;
        requested = Math.max(minimum, Math.min(maximum, requested));
        quantity.value = String(requested);
      }
      const allocations = planData[currentVariantId()] || [];
      const allowed = new Set(allocations.map(allocation => String(allocation.id)));
      if (plan) {
        const requiresPlan = option ? option.dataset.requiresPlan === 'true' : plan.dataset.requiresPlan === 'true';
        plan.required = requiresPlan;
        [...plan.options].forEach(item => {
          if (!item.value) { item.disabled = requiresPlan; item.hidden = requiresPlan; }
          else item.disabled = !allowed.has(item.value);
        });
        if (plan.value && !allowed.has(plan.value)) {
          const fallback = [...plan.options].find(item => !item.disabled);
          plan.value = fallback?.value || '';
        } else if (requiresPlan && !plan.value) {
          const fallback = [...plan.options].find(item => item.value && !item.disabled);
          plan.value = fallback?.value || '';
        }
      }
      const allocation = allocations.find(item => String(item.id) === plan?.value);
      if (allocation && price) {
        price.textContent = allocation.price;
        if (compare) { compare.textContent = allocation.compare || ''; compare.hidden = !allocation.compare; }
      } else if (option && price) {
        price.textContent = option.dataset.price || price.textContent;
        if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice; }
      } else if (price) {
        price.textContent = originalPrice;
        if (compare) { compare.textContent = originalCompare; compare.hidden = !originalCompare; }
      }
    };
    variant?.addEventListener('change', update);
    plan?.addEventListener('change', update);
    update();
  }
  const init = root => initProduct(root || document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
